import { createContext } from "react";
const queryContext  = createContext(null);
export default queryContext ; 